import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Video } from "lucide-react";

// Technique videos awaiting trainer review.
const VideosTab = ({
  setSelectedVideo,
  setVideoReviewOpen,
  techniqueVideos,
}) => {
  return (
    <div className="videos-view">
      <div className="view-header">
        <h1>Przegląd techniki</h1>
      </div>

      {techniqueVideos.length === 0 ? (
        <Card className="empty-state">
          <CardContent>
            <Video size={48} strokeWidth={1} />
            <h3>No videos to review</h3>
            <p>Clients can send technique videos for your feedback</p>
          </CardContent>
        </Card>
      ) : (
        <div className="videos-list">
          {techniqueVideos.map(video => (
            <Card key={video.id} className={`video-card clickable-card ${video.status}`} onClick={() => { setSelectedVideo(video); setVideoReviewOpen(true); }}>
              <CardContent>
                <div className="video-preview">
                  <Video size={32} />
                </div>
                <div className="video-info">
                  <h3>{video.exercise_name}</h3>
                  <p>From: {video.client_name}</p>
                  <span className={`video-status ${video.status}`}>
                    {video.status === 'pending' ? 'Awaiting review' : 'Reviewed'}
                  </span>
                </div>
                <Button
                  variant={video.status === 'pending' ? 'default' : 'outline'}
                  size="sm"
                  onClick={(e) => { e.stopPropagation(); setSelectedVideo(video); setVideoReviewOpen(true); }}
                >
                  {video.status === 'pending' ? 'Review' : 'View'}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideosTab;
